// extracted by mini-css-extract-plugin
module.exports = {"header":"NOYdEqih","leftPlaceholder":"Fd79_MxW","active":"yg4bvMju"};